import { all, fork, put, takeEvery } from "redux-saga/effects";
// import { useIntl } from 'react-intl';
import {
    BOOKING_LOAD_BOOKING_TOPBAR,
    // BOOKING_LOAD_BOOKING_LIST_SUCCESS
} from "../actions";
import {
    bookingGetBookingTopbar
} from "../../helpers/booking-api";
import { NotificationManager } from '../../components/common/react-notifications';
import {
    // getBooklist,
    getBookingTopbarDataSuccess,
} from "./actions";

// const intl = useIntl();
const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}
//  booking
function* bookingLoadBookingTopbar({ payload, token }) {
    try {
        const dt = new Date();
        const dateTime = `${dt.getFullYear().toString().padStart(4, '0')}/${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getDate().toString().padStart(2, '0')}`
        const dataRes = yield bookingGetBookingTopbar({ ...payload, dateTime }, token);
        if (dataRes.status === 'success') {
            yield put(getBookingTopbarDataSuccess(dataRes.data));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* companyDetailLoadCompanyInformation({ payload, token }) {
//     try {
//         // console.log('companyDetailLoadRoleSpa', payload, token)
//         const dataRes = yield companyDetailGetCompanyInformation(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getCompanyInformationSuccess(dataRes.data));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield NotificationManager.warning("TIME OUT! Please Login again.", 'Error', 3000, null, null, '');
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield NotificationManager.warning("OMG! Please wait about 30s and refresh your browser again.", 'Error', 3000, null, null, '');
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield NotificationManager.warning("OMG! Please wait about 30s and refresh your browser again.", 'Error', 3000, null, null, '');
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* companyDetailUpdateUser({ payload, token }) {
//     try {
//         const dataRes = yield companyDetailUpdateCompanyProfile(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getSpa({ spa_id: payload.spa_id }, token));
//             yield put(getCompanyInformation({ spa_id: payload.spa_id }, token));
//             yield put(updateCompanyProfileSuccess())
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield NotificationManager.warning("Oops! The data name is duplicated. Please change the data name.", 'Error', 3000, null, null, '');
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield NotificationManager.warning("TIME OUT! Please Login again.", 'Error', 3000, null, null, '');
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield NotificationManager.warning(dataRes.msg, 'Error', 3000, null, null, '');
//                 // yield put(settingErrorMessage(`${dataRes.msg}`));
//             }

//     } catch (error) {
//         yield NotificationManager.warning("OMG! Please wait about 30s and refresh your browser again.", 'Error', 3000, null, null, '');
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }


// Booklist
export function* watchLoadBookingTopbar() {
    yield takeEvery(
        BOOKING_LOAD_BOOKING_TOPBAR,
        bookingLoadBookingTopbar
    );
}
// export function* watchLoadCompanyInformation() {
//     yield takeEvery(
//         COMPANY_DETAIL_LOAD_COMPANY_INFORMATION,
//         companyDetailLoadCompanyInformation
//     );
// }
// export function* watchUpdateUser() {
//     yield takeEvery(
//         COMPANY_DETAIL_UPDATE_COMPANY_PROFILE,
//         companyDetailUpdateUser
//     );
// }

export default function* rootSaga() {
    yield all([
        //  Book list
        fork(watchLoadBookingTopbar),
        // fork(watchLoadCompanyInformation),
        // fork(watchUpdateUser),
    ])
}